import { makeStyles } from '@mui/styles'
import {
  ALICE_BLUE,
  AMBER,
  ERROR,
  MIDNIGHT_EXPRESS,
  NEON_BLUE_LIGHT,
  RAVEN,
  SHAMROCK,
  SOLITUDE,
  SONIC_SILVER,
} from '@returnmates/client-core/src/constants/colors'
import { URBANIST } from '@returnmates/ui-core/src/constants/styles/fonts'

import { POPPINS } from '../../constants/styles/fonts'

const useStyles = makeStyles(() => ({
  iconCell: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  packagesInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    margin: '10px 0',
  },
  packagesTable: {
    border: 'none',
  },
  newPackageModal: {
    padding: '55px 25px 15px',
    overflow: 'hidden',
  },
  modalHeader: {
    fontFamily: POPPINS,
    fontWeight: 600,
    fontSize: 30,
    lineHeight: '130%',
    color: MIDNIGHT_EXPRESS,
    textAlign: 'center',
    paddingTop: 10,
  },
  modalSubHeader: {
    marginBottom: 10,
    fontFamily: POPPINS,
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '160%',
    color: RAVEN,
    marginTop: '10px',
    padding: '0 20px',
    textAlign: 'center',
  },
  buttonsGroup: {
    marginTop: 10,
    display: 'flex',
  },
  button: {
    textTransform: 'capitalize',
    fontFamily: POPPINS,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '130%',
    borderRadius: '4px',
    padding: '10px 0',
    width: '130px',
  },
  cancelButton: {
    marginRight: '10px',
    marginLeft: 'auto',
    backgroundColor: ALICE_BLUE,
    border: `1px solid ${SOLITUDE}`,
    color: MIDNIGHT_EXPRESS,
    '&:hover': {
      backgroundColor: ALICE_BLUE,
    },
  },
  modalCancelButton: {
    minWidth: '150px',
  },
  saveButton: {
    backgroundColor: NEON_BLUE_LIGHT,
    border: `1px solid ${NEON_BLUE_LIGHT}`,
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: NEON_BLUE_LIGHT,
    },
  },
  modalSaveButton: {
    width: '100%',
  },
  modalDetailsRow: {
    marginTop: 10,
    textAlign: 'left',
    '&:last-child': {
      marginBottom: 10,
    },
  },
  optionPrimary: {
    fontFamily: POPPINS,
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '160%',
    color: MIDNIGHT_EXPRESS,
    cursor: 'pointer',
  },
  error: {
    paddingTop: 10,
    fontFamily: POPPINS,
    fontSize: 14,
    color: ERROR,
    textAlign: 'start',
  },
  toolbar: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    padding: '15px',
  },
  toolbarLeftPart: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '80%',
  },
  toolbarRightPart: {
    minWidth: 'max-content',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '20%',
  },
  scannedListBlock: {
    marginTop: 13,
  },
  scannedListTitle: {
    fontFamily: POPPINS,
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '15px',
    color: MIDNIGHT_EXPRESS,
  },
  scannedIdsBlock: {
    marginTop: 10,
  },
  scannedId: {
    fontFamily: POPPINS,
    fontWeight: 400,
    fontSize: 13,
    lineHeight: '15px',
    color: RAVEN,
    display: 'flex',
    alignItems: 'center',
    minHeight: 18,
  },
  scannedIdRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 5,
  },
  redCross: {
    height: '100%',
    width: '18px',
    marginLeft: 5,
    '& > path': {
      stroke: ERROR,
    },
  },
  greenCheck: {
    height: '100%',
    width: '18px',
    marginLeft: 5,
    '& path': {
      stroke: SHAMROCK,
    },
  },
  circularProgress: {
    marginLeft: 5,
    color: SHAMROCK,
  },
  iconButtonSecond: {
    padding: 0,
  },
  simulateScanBtn: {
    marginTop: 5,
    width: '100%',
  },
  simulateScanBlock: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${AMBER}`,
    padding: '10px',
  },
  filters: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 10,
  },
  clearFilters: {
    fontSize: 14,
    fontFamily: URBANIST,
    fontWeight: 700,
    background: 'transparent',
    color: SONIC_SILVER,
    height: 40,

    '&:hover': {
      background: 'transparent',
    },
  },
  addConsolidationButton: {
    padding: '8.5px 23px',
  },
  plusIcon: {
    '& path': {
      stroke: '#FFFFFF',
    },
  },
}))

export default useStyles
